import { UserRecordDTO, UserProfile } from '../types';

export default class TypeMapping {

  static mapUserRecordToUserProfile(userRecord: UserRecordDTO): UserProfile {
    // NOTE: Some values are hard coded for now. They either need to be removed or correctly assigned if needed.
    let roles = [];
    if (userRecord.is_employee) {
      roles = ['Employee', 'Admin'];
    }
    else if (userRecord.is_admin) {
      roles = ['RegUser', 'Admin'];
    } else {
      roles = ['RegUser'];
    }
    const userProfile: UserProfile = {
      active: userRecord.is_active,
      email: userRecord.email_address,
      emailConfirmed: true,
      firstName: userRecord.first_name,
      fullName: userRecord.first_name + ' ' + userRecord.last_name,
      hasExpiredPassword: false,
      id: userRecord.user_guid,
      accountId: userRecord.account_guid,
      created_timestamp: userRecord.created_timestamp,
      lastName: userRecord.last_name,
      level: 1,
      passwordExpirationUTC: 'Unknown',
      phoneNumber: userRecord.phone_number,
      phoneNumberConfirmed: true,
      roles: roles,
      sessionEnabled: true,
      userName: userRecord.email_address,
    }
    return userProfile;
  }
}